import React, { useContext } from 'react';
import {
    Box,
    Button,
    MenuItem,
    Grid,
    TextField,
} from '@mui/material';
import '../../assets/styles/FilterBar.scss';
import { TaskMasterContext } from '../../context';
import { status } from '../../utils/config';

export default function FilterBar() {
    const { filters, setFilters, initialFilters, onLoadApi } = useContext(TaskMasterContext);

    const handleChange = (key, value) => {
        setFilters(prev => ({ ...prev, [key]: value }));
    };

    const handleSubmit = () => {
        onLoadApi();
    };

    const handleReset = () => {
        setFilters(initialFilters);
        onLoadApi(initialFilters);
    };

    return (
        <Box className="shipment-filter-bar">
            <Grid container spacing={2}>
                <Grid item size={{ xs: 6, md: 4 }}>
                    <div className="search-box">
                        <TextField
                            select
                            name="searchBy"
                            value={filters.searchBy}
                            onChange={(e) => handleChange('searchBy', e.target.value)}
                            size="small"
                            className="search-select"
                            SelectProps={{
                                displayEmpty: true,
                            }}
                        >
                            <MenuItem value="task_master">Task Master</MenuItem>
                        </TextField>

                        <TextField
                            size="small"
                            placeholder={`Enter ${filters.searchBy
                                ?.toLowerCase()
                                .replace(/\./g, '')
                                .replace(/[_-]/g, ' ') || 'value'} here`}
                            value={filters.searchValue}
                            onChange={(e) => handleChange('searchValue', e.target.value)}
                            className="search-input"
                        />
                    </div>
                </Grid>

                <Grid item size={{ xs: 6, md: 4 }}>
                    <TextField
                        select
                        label="Status"
                        name="status"
                        value={filters.status}
                        onChange={(e) => handleChange('status', e.target.value)}
                        fullWidth
                        size="small"
                    >
                        <MenuItem value="">Status</MenuItem>
                        {Object.entries(status).map(([key, value]) => (
                            <MenuItem value={key} key={key}>
                                {value}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>

                <Grid item size={{ xs: 12, md: 4 }}>
                    <Box className="filter-actions">
                        <Box>
                            <Button className="search-btn" variant="contained" color="primary" size="medium" onClick={handleSubmit}>
                                Search
                            </Button>

                            <Button className="reset-btn ml-2" variant="outlined" color="primary" size="medium" onClick={handleReset}>
                                Reset
                            </Button>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
}
